import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { BeneficiaryIS } from '@interfaces/services/beneficiary.interfaces';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryService {
  constructor(private _http: HttpClient) {}

  async findByRut(rut: string): Promise<BeneficiaryIS> {
    const result = await firstValueFrom<ResponseCommonSI<BeneficiaryIS>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.BENEFICIARY}/${rut}`)
    );
    return result.payload;
  }

  async save(
    body
  ): Promise<{ idBeneficiary: string; additionalBeneficiaries: string[] }> {
    const result = await firstValueFrom<
      ResponseCommonSI<{
        idBeneficiary: string;
        additionalBeneficiaries: string[];
      }>
    >(this._http.post(`${BASE_URL}${ENDPOINTS.BENEFICIARY}`, body));
    return result.payload;
  }
}
